// Unpublished Work © 2020-2025 Deere & Company.

import t from 'tcomb';
import {Locale} from './locale';
import {AdminActivities} from './admin-activities';

export const User = t.struct({
    country: t.String,
    dbsSourceSystemId: t.String,
    featureFlags: t.dict(t.String, t.Boolean),
    locale: t.String,
    r2ProfileUser: t.Boolean,
    impersonateUserId: t.String,
    isCSC2User: t.Boolean,
    adminActivities: AdminActivities,
    loggedInUserId: t.String,
    isUserRedirectedToSearch: t.Boolean,
    isUserRedirectedToProfile: t.Boolean,
    r2CRMUser: t.Boolean,
    r2CRMSourceSystemId: t.String,
    isBranch29User: t.Boolean
}, {
    defaultProps: {
        country: '',
        dbsSourceSystemId: '',
        featureFlags: {},
        locale: Locale.meta.map['en-US'],
        r2ProfileUser: true,
        impersonateUserId: '',
        isCSC2User: false,
        adminActivities: {},
        loggedInUserId: '',
        isUserRedirectedToSearch: false,
        isUserRedirectedToProfile: false,
        r2CRMUser: false,
        r2CRMSourceSystemId: '',
        isBranch29User: false
    },
    name: 'User',
    strict: true
});
